export default __webpack_public_path__ + "static/media/Anova-Italic.2b81346c.woff2";